import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4ae97126")

_pushScopeId("data-v-4ae97126")
const _hoisted_1 = { class: "toc_ui__navigation_main" }
const _hoisted_2 = { class: "toc_ui__head_top_listCont" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return _withDirectives((_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("ul", {
        class: ["toc_ui__head_top_list", {"mt0": !_ctx.state.hasWarn}],
        id: "checkItemList"
      }, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.tabList, (item) => {
          return (_openBlock(), _createBlock("li", {
            onClick: ($event: any) => (_ctx.clickTab(item.itemCode, $event)),
            key: item.itemCode,
            id: `${item.itemCode}1`,
            class: ["toc_ui__head_top_listItem", {'toc_ui__head_top_listItem_active': _ctx.state.currentName === item.itemCode}]
          }, _toDisplayString(item.itemTitle), 11, ["onClick", "id"]))
        }), 128))
      ], 2)
    ])
  ], 512)), [
    [_vShow, _ctx.state.isShowTopNav]
  ])
})